import { useEffect, useRef } from 'react'

export default function ParallaxBackground() {
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!imgRef.current) return

      const x = (e.clientX / window.innerWidth - 0.5) * 20
      const y = (e.clientY / window.innerHeight - 0.5) * 20

      imgRef.current.style.transform = `scale(1.1) translate(${x}px, ${y}px)`
    }

    document.addEventListener('mousemove', handleMouseMove)
    return () => document.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <>
      {/* Parallax Background */}
      <div className="fixed inset-0 -top-8 -left-8 -right-8 -bottom-8 z-0 overflow-hidden">
        <picture className="block w-full h-full">
          <source
            media="(max-width: 600px)"
            srcSet="https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&q=70"
          />
          <source
            media="(max-width: 1200px)"
            srcSet="https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=75"
          />
          <img
            ref={imgRef}
            src="https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80"
            alt=""
            className="w-[calc(100%+60px)] h-[calc(100%+60px)] object-cover scale-110 transition-transform duration-300 ease-out"
            style={{ filter: 'brightness(0.25) saturate(0.7)' }}
            loading="eager"
          />
        </picture>
      </div>

      {/* Gradient Overlay */}
      <div
        className="fixed inset-0 z-[1] pointer-events-none"
        style={{
          background: `linear-gradient(
            180deg,
            rgba(10, 10, 10, 0.7) 0%,
            rgba(10, 10, 10, 0.4) 50%,
            rgba(10, 10, 10, 0.8) 100%
          )`
        }}
      />
    </>
  )
}
